import { SUBSCRIPTION_TIERS } from '../core/types/SystemConfig';

type GtagParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: string, params: GtagParams = {}): void {
  window.gtag?.('event', name, params);
}

export function trackPurchase(sessionId: string, tierKey: string, billingCycle: string): void {
  const storageKey = `purchase_tracked_${sessionId}`;
  if (sessionStorage.getItem(storageKey)) return;
  const tier = SUBSCRIPTION_TIERS.find(t => t.key === tierKey);
  if (!tier) return;
  const value = billingCycle === 'annual' ? tier.priceAnnually : tier.priceMonthly;
  sessionStorage.setItem(storageKey, '1');
  trackEvent('purchase', { transaction_id: sessionId, value, currency: 'AUD', tier_key: tierKey });
}
